<script>
import config from './../../config';
import axios from 'axios';
import utils from './../../utils';
export default {
    name: 'ViewModal',
    data: () => ({
        rules: [
            value => !!value || 'Obligatorio.',
            value => (value && value.length >= 3) || 'Min 3 characters',
        ],
        customerCode: '',
    }),
    methods: {
        close() {
            this.$emit('close');
        },
        saveCustomerCode() {

            axios.get(`${config.VUE_APP_API_URL}venusa/getNameCustomer`, { params: { UNIDADE_PAIS: utils.loadCountry(), USERID: utils.loadUserId(), CUSTOMER: this.customerCode, TOKEN: utils.loadToken() } })
                .then(({ data }) => {

                    if (!data.success) {
                        alert('Cliente não identificado no país!');
                        return false;
                    }

                    localStorage.setItem('customerId', this.customerCode)
                    localStorage.setItem('nameCustomer', data.NAME)
                    this.customerCode = '';
                    this.$emit('setNameCustomer');
                    this.close();
                });
        }
    },
};
</script>

<template>
        <transition name="modal-fade">
            <div class="modal-backdrop">
                <div class="modal" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription">
                    <header class="modal-header" id="modalTitle">
                        <slot name="header">
                            Introduce el NIT de cliente
                        </slot>
                        <button
                        type="button"
                        class="btn-close"
                        @click="close"
                        >
                        x
                        </button>
                    </header>

                    <section class="modal-body" id="modalDescription">
                        <div style="margin-bottom: 30px;">
                            <v-text-field label="NIT cliente" :rules="rules" hide-details="auto" type="number"
                                v-model="customerCode"></v-text-field>
                        </div>
                        <v-btn elevation="2" @click="saveCustomerCode()">Buscar</v-btn>
                    </section>
                </div>
            </div>
        </transition>
</template>

<style>
.modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 8;
}

.modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    width: 30%;
    color: rgba(0, 0, 0, 0.54) !important;
    font-weight: normal;
    font-family: Roboto, sans-serif !important;
    font-size: 0.85em;
}

.modal-header,
.modal-footer {
    padding: 15px;
    display: flex;
}

.modal-header {
    color: rgba(0, 0, 0, 0.54) !important;
    font-weight: normal;
    font-family: Roboto, sans-serif !important;
    font-size: 0.85em;
    position: relative;
    border-bottom: 1px solid #eeeeee;
    justify-content: space-between;
}

.modal-footer {
    border-top: 1px solid #eeeeee;
    flex-direction: column;
}

.modal-body {
    position: relative;
    padding: 20px 10px;
}

.btn-close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    font-size: 20px;
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
    color: #4AAE9B;
    background: transparent;
}

.btn-green {
    color: white;
    background: #4AAE9B;
    border: 1px solid #4AAE9B;
    border-radius: 2px;
}

.modal-fade-enter,
.modal-fade-leave-to {
    opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity .5s ease;
}
</style>